import { useCountUp } from "@/hooks/useCountUp";
import { SEVERITY_COLORS } from "@/lib/api";

/** Minimalist SVG ring gauge for the Founder Dependency Index. */
export const ScoreDial = ({ score, severityKey, severityLabel, unitLabel = "of 100", animate = true }) => {
  const value = useCountUp(score, 1600, animate);
  const size = 260;
  const stroke = 6;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const color = SEVERITY_COLORS[severityKey] || "#0B0E14";
  const offset = c - (value / 100) * c;

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="score-dial">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2DFD8" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeDasharray={c}
          strokeDashoffset={offset}
          strokeLinecap="butt"
          style={{ transition: "stroke-dashoffset 0.1s linear" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <div className="font-display text-7xl font-light tracking-tight text-[#0B0E14] tabular-nums" data-testid="score-value">
          {value}
        </div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#718096] mt-1">{unitLabel}</div>
        <div
          className="text-xs font-semibold uppercase tracking-[0.18em] mt-4"
          style={{ color }}
          data-testid="severity-label"
        >
          {severityLabel}
        </div>
      </div>
    </div>
  );
};
